export const PAGE_TYPE_INDUSTRY = 'industry';
export const PAGE_TYPE_TAG = 'tag';
